import React, { useState, useEffect, useRef } from "react";

import Image from "next/image";
import Link from "next/link";

// import AppLogo from '../../../public/assets/img/ted-logo.svg'
import AppLogo from "../../../public/assets/img/app-logo.png";

// import LoginIcon from '../../../public/assets/img/login-icon.svg'
// import ButtonLoader from '../../../public/assets/img/icons/Loader1.svg'

// import {submitLogin} from '../../../../../lib/db'

import LogInForm from "./LogIn";

const LoginView = () => {
  return (
    <section className="grid lg:grid-cols-12 grid-cols-1 items-center">
      <div className="lg:col-span-4 col-span-1">
        <header className="relative py-8 lg:h-screen h-auto">
          <div className="relative w-full md:max-w-[120px] max-w-[85px] mx-auto z-30">
            <Link href="/">
              <a className="">
                <Image src={AppLogo} alt="PMHA" />
              </a>
            </Link>
          </div>
          <div className="absolute left-0 right-0 bottom-0 z-30 p-10 lg:block hidden">
            <p className="text-white uppercase px-2 text-sm text-left tracking-wider">
              PMHA {new Date().getFullYear()}. All Rights Reserved.
            </p>
            <p className="text-white uppercase px-2 text-sm text-left tracking-wider">
              Powered by{" "}
              <Link href="https://kynatech.ph/">
                <a target="_blank" className="text-white">
                  kynatech.ph
                </a>
              </Link>
              .
            </p>
          </div>
          <div className="absolute inset-0 gradient-bg z-20 bg-gradient-to-b from-white to-blue opacity-80"></div>
          <div className="absolute inset-0 bg-1 z-10"></div>
        </header>
      </div>
      <div className="lg:col-span-8 col-span-1">
        <div className="max-w-screen-sm mx-auto lg:py-16 py-10 sm:px-14 px-8">
          <div className="">
            <h1 className="sm:text-4xl text-3xl mb-3">Welcome back! ✨</h1>
            <p className="text-lg text-blue font-bold mb-10">
              Exclusive to PMHA Staff, Patients, and Doctors only.
            </p>
            <LogInForm />
          </div>
          <div className="relative lg:hidden block mt-20">
            <p className="uppercase text-xs text-left tracking-wider">
              PMHA {new Date().getFullYear()}. All Rights Reserved.
            </p>
            <p className="uppercase text-xs text-left tracking-wider">
              Powered by{" "}
              <Link href="https://kynatech.ph/">
                <a target="_blank" className="">
                  kynatech.ph
                </a>
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginView;
